import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const exportMerchantSupportThreads = {
  name: "exportMerchantSupportThreads" as const,

  input: z.object({
    agentNames: z.array(z.string()),
    searchQuery: z.string().optional(),
    calledAgentFilter: z.string().optional(),
    escalationFilter: createEnum(["yes", "no"]).optional(),
    channelTypeFilter: createEnum([
      "general",
      "support",
      "ask-redo",
    ]).optional(),
    sourceFilter: createEnum([
      "slack",
      "ai-draft",
      "ai-draft-slack",
      "ai-draft-intercom",
      "email",
    ]).optional(),
    dateRange: z
      .object({ start: z.date().nullable(), end: z.date().nullable() })
      .optional(),
    internal: z.boolean().optional(),
  }),

  output: z.object({
    threads: z.array(
      z.object({
        _id: z.string(),
        teamId: z.string().optional(),
        teamName: z.string().optional(),
        userEmail: z.string(),
        createdAt: z.date(),
        hasEscalation: z.boolean(),
        calledAgents: z.array(z.string()),
        messages: z.array(z.object({ role: z.string(), content: z.string() })),
      }),
    ),
  }),
};
